window.dataTables = {};

function resolve(path, obj) {
    return path.split('.').reduce(function(prev, curr) {
        return prev ? prev[curr] : null
    }, obj || self)
}


app.directive("acDataTable", ['$rootScope','$timeout', function($rootScope, $timeout) {
    return {
        link: function(scope, element, attributes) {
            var foodTable = undefined;
            var myName = attributes.acDataTable;
            $timeout(function(foodTable){
                foodTable = new mdc.dataTable.MDCDataTable(element[0])
                //window.dataTables[myName] = foodTable;
                if(scope.dataTables == undefined){
                    scope.dataTables = {};
                }
                
                scope.dataTables[myName] = {};
                scope.dataTables[myName].mdcComponent = foodTable;
                $rootScope.$on("ACDataTable:"+myName+":newData", function(){
                    scope.dataTables[myName].mdcComponent.foundation_.layoutAsync()
                })

                scope.dataTables[myName].adapter = {};
                scope.dataTables[myName].hasSelected = false;
                scope.dataTables[myName].phantomFields = {};
                scope.dataTables[myName].showPhantomEntry = false;
                scope.dataTables[myName].phantomEntry = {showCheck: false};
                
                //Deprecated
                scope.dataTables[myName].showPhantomCheck = function(){
                    console.warn("deprecated")
                    $(element).find("[ac-data-table-check]").css("display", "block");
                }
                
                scope.dataTables[myName].closePhantomEntry = function(){
                    console.warn("deprecated")
                    $(element).find("[ac-data-table-check]").css("display", "none");
                    scope.showPhantomEntry = false
                }
                
                //Find Phantomfields
                var phantomFields = $(element).find("[ac-datatable-isphantomfield]");
                var validatePhantomFields = function(){
                    var isValid = true;
                    phantomFields.each(function(i){
                        var field = $(phantomFields.get(i))
                        var type= field.attr("ac-datatable-isphantomfield")
                        if(field.attr("required") != undefined){
                            if(type == "ACSelect"){
                                var model = field.attr("ac-select")
                                var value = resolve(model, scope);
                                if(value == "" || value == undefined){
                                    isValid = false;
                                    console.log("drop is false")
                                }
                            }else if(type == "ACDropDownSearch"){
                                var name = field.parent().attr("ac-search")
                                var key = field.parent().attr("ac-object-key")
                                var value = scope.searches[name].result;
                                scope.dataTables[myName].phantomFields[key] = value;
                                if(value == "" || value == undefined){
                                    isValid = false;
                                    console.log("search is false")
                                }
                            }else{
                                if(field.val() != "" && field.val() != undefined){
                                    //isValid = true;
                                }else{
                                    isValid = false;
                                }
                            }
                        }
                    })
                    return isValid;
                }
                
                phantomFields.each(function(i){
                        var field = $(phantomFields.get(i))
                        var type= field.attr("ac-datatable-isphantomfield")
                        if(type == ""){
                            field.on("keyup", function(){
                                var isValid = validatePhantomFields()
                                $timeout(function(){
                                    scope.dataTables[myName].phantomEntry.showCheck = isValid;
                                })
                            })
                        }
                })
                
                scope.dataTables[myName].adapter.phantomFieldChanged = function(){
                    var isValid = validatePhantomFields()
                    $timeout(function(){
                        scope.dataTables[myName].phantomEntry.showCheck = isValid;
                    })
                }
                
                
                if(attributes.acDataSrcType == "operation"){
                    var dataSrc = attributes.acDataSrc;
                    scope.dataTables[myName]._tableData = pipeVariables[dataSrc]
                }
                
                scope.openIdLink = function(selectedObject,page, id){
                    var link = "/"+page+"/"+selectedObject[id];
                    window.location = link;
                }
                
                //------------Finished Initiation
                $rootScope.$emit("ACDataTable:"+myName+":finished")
                
                var hasDeleteButton = $(element).find("[ac-menu-deletebutton]").length==1;
                
                if(scope.dataTables[myName].saveEntry == undefined){
                    console.warn("ACComponentWarning: 'saveEntry' listener not set for phantomentry is set for ACDataTable: "+myName)
                }else{
                    scope.dataTables[myName].savePhantomEntry = function(){
                        scope.dataTables[myName].saveEntry(scope.dataTables[myName].phantomFields)
                        $timeout(function(){
                            scope.dataTables[myName].showPhantomEntry=false;
                        })
                    }
                }

                if(scope.dataTables[myName].removeEntry == undefined){
                    if(hasDeleteButton)
                        console.warn("ACComponentWarning: 'removeEntry' listener not set for phantomentry is set for ACDataTable: "+myName)
                }else{
                    scope.dataTables[myName].removeSelectedEntries = function(){
                        var selected = scope.dataTables[myName].selected.slice();
                        if(selected[0] == "phantom"){
                            selected.shift()
                        }
                        scope.dataTables[myName].removeEntry(selected)
                    }
                }
                
                $(element).find("[ac-data-table-check]").parent().on("click", function(){
                    scope.dataTables[myName].savePhantomEntry();
                })

                foodTable.listen(mdc.dataTable.events.ROW_SELECTION_CHANGED, function(f){
                    var selectedRows = foodTable.getSelectedRowIds();
                    scope.dataTables[myName].selected = selectedRows;
                    scope.dataTables[myName].hasSelected = (selectedRows.length > 0 && !(selectedRows.length == 1 && selectedRows.indexOf("phantom") != -1));
                })
                foodTable.listen(mdc.dataTable.events.SELECTED_ALL, function(f){
                    var selectedRows = foodTable.getSelectedRowIds();
                    scope.dataTables[myName].selected = selectedRows;
                    scope.dataTables[myName].hasSelected = (selectedRows.length > 0 && !(selectedRows.length == 1 && selectedRows.indexOf("phantom") != -1));
                })
                foodTable.listen(mdc.dataTable.events.UNSELECTED_ALL, function(f){
                    var selectedRows = foodTable.getSelectedRowIds();
                    scope.dataTables[myName].selected = selectedRows;
                    scope.dataTables[myName].hasSelected = (selectedRows.length > 0 && !(selectedRows.length == 1 && selectedRows.indexOf("phantom") != -1));
                })
            })
        }
    }
}]);